import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { CustomerData, getCustomerQuery, ActionButtons } from "./details-page";
import { useCurrentCustomerContext } from "components/current-customer-context";
import { deleteCustomerMutation } from "./table";
import { parsePage } from "components/table";
import { CustomerContractsTable } from "./contract-table";
import { CustomerUsersTable } from "./user-table";

const CustomerDetailsPage = ({
  match: {
    params: { id },
  },
  location: { search },
  history,
}) => {
  const { currentCustomerId } = useCurrentCustomerContext();
  const query = useMemo(() => getCustomerQuery(id), [id]);
  const { data, loading, error } = useQuery(query);

  const customer = data.customer;

  const customerName = customer ? customer.description : "";

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={customer}>
        <PageHeaderBar
          showBackButton
          title="app.page.customer.details.title"
          titleParams={{ customerName: customer ? customer.description : null }}
          buttons={
            <ActionButtons
              id={id}
              customerId={currentCustomerId}
              name={customerName}
              mutation={deleteCustomerMutation}
              history={history}
            />
          }
        />
        <PageSection>
          <CustomerData customer={customer} />
        </PageSection>
        {!!customer?.contracts?.length && (
          <>
            <PageHeaderBar subtitle title="app.page.contract.list" />
            <PageSection hideBackground>
              <CustomerContractsTable
                page={parsePage({ queryParams: search, pageName: "contractsPage" })}
                variables={{ customerId: customer.id }}
              />
            </PageSection>
          </>
        )}
        {!!customer?.users?.length && (
          <>
            <PageHeaderBar subtitle title="app.page.user.list" />
            <PageSection hideBackground>
              <CustomerUsersTable
                page={parsePage({ queryParams: search, pageName: "usersPage" })}
                variables={{ customerId: customer.id }}
              />
            </PageSection>
          </>
        )}
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default CustomerDetailsPage;
